// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const personalInfoGrid = "SettingsPage__personalInfoGrid__Uz+v4";
export const gridCell = "SettingsPage__gridCell__ze8lQ";
export const accountModuleCell = "SettingsPage__accountModuleCell__oOILj SettingsPage__gridCell__ze8lQ";
export const profileModuleCell = "SettingsPage__profileModuleCell__gWh38 SettingsPage__gridCell__ze8lQ";
export const subscriptionModuleCell = "SettingsPage__subscriptionModuleCell__f6O7L SettingsPage__gridCell__ze8lQ";
export const contactModuleCell = "SettingsPage__contactModuleCell__zSJ-1 SettingsPage__gridCell__ze8lQ";
export const footerWrapper = "SettingsPage__footerWrapper__HTgxR";
export const version = "SettingsPage__version__jwbnl";